import React, { Component } from 'react'
import Style from './RiskProfileDetails.module.css'
import { formatDetectionDatetime } from '../../utilities/datetime'
import { connect } from 'react-redux'
import { loadRiskProfileById } from '../../store/entities/credentialMonitoring'
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper'
import backButton from '../../assets/backButton.svg'

class RiskProfileDetails extends Component {

    componentDidMount() {
        const { loadRiskProfileById, selectedCustomer, match } = this.props;
        const customerId = match.params.id || (selectedCustomer ? selectedCustomer.id : null);
        const userId = match.params.userId;
        if (customerId && userId) {
            loadRiskProfileById(customerId, userId);
        }
    }

    handleReturn = () => {
        const { match, selectedCustomer } = this.props;
        const customerId = match.params.id || (selectedCustomer ? selectedCustomer.id : null);
        this.props.history.push(`/customers/${customerId}/risk-profiles`);
    }

    renderPasswordTable = (accounts) => (
        <table className={Style.dataTable}>
            <thead>
                <tr>
                    <td className={`py-3 px-2`} style={{ width: '50%' }}>
                        <b>Domain</b>
                    </td>
                    <td className={`py-3 px-2`} style={{ width: '50%' }}>
                        <b>Last Detected</b>
                    </td>
                </tr>
            </thead>
            <tbody>
                {accounts.map((account, index) => (
                    <tr
                        key={index}
                        style={{ background: index % 2 === 0 ? '#fff' : '#f7f7f7' }}
                    >
                        <td className={`py-3 px-2`}>{account.host}</td>
                        <td className={`py-3 px-2`}>
                            {formatDetectionDatetime(account.lastDetected)}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )

    render() {
        const { selectedRiskProfile, loading } = this.props
        const compromisedAccounts = selectedRiskProfile.filter(account => account.isCompromised)
        const weakPasswordAccounts = selectedRiskProfile.filter(account => account.isWeak)
        const strongPasswordAccounts = selectedRiskProfile.filter(account => !account.isCompromised && !account.isWeak)

        return (
            <div className={'mt-4'} style={{ paddingLeft: '75px', marginRight: '33px' }}>
                <div className="pointer mb-3" onClick={this.handleReturn}>
                    <img width="25px" src={backButton} alt="" srcSet="" />
                    <span> Return to Credential Monitoring</span>
                </div>
                <LoaderWrapper
                    loading={loading}
                    data={selectedRiskProfile}
                    waitForData={true}
                    styles={{ minHeight: '300px' }}
                    placeholderText="No data found"
                >
                    <div className={`mt-4`} style={{ minHeight: '300px' }}>
                        <h4>{selectedRiskProfile.length > 0 && selectedRiskProfile[0].userId}</h4>

                        {/* Compromised Passwords Section */}
                        <div className={`${Style.detailsContainer} mt-4`}>
                            <div className={'p-4'}>
                                <div className={'mb-3'}>
                                    <b>Compromised Passwords ({compromisedAccounts.length})</b>
                                </div>
                                {compromisedAccounts.length > 0 ? (
                                    this.renderPasswordTable(compromisedAccounts)
                                ) : (
                                    <div className={Style.emptyState}>No compromised passwords found</div>
                                )}
                            </div>
                        </div>

                        {/* Weak Passwords Section */}
                        <div className={`${Style.detailsContainer} mt-4`}>
                            <div className={'p-4'}>
                                <div className={'mb-3'}>
                                    <b>Weak Passwords ({weakPasswordAccounts.length})</b>
                                </div>
                                {weakPasswordAccounts.length > 0 ? (
                                    this.renderPasswordTable(weakPasswordAccounts)
                                ) : (
                                    <div className={Style.emptyState}>No weak passwords found</div>
                                )}
                            </div>
                        </div>

                        {/* Safe Passwords Section */}
                        <div className={`${Style.detailsContainer} mt-4`}>
                            <div className={'p-4'}>
                                <div className={'mb-3'}>
                                    <b>Safe Passwords ({strongPasswordAccounts.length})</b>
                                </div>
                                {strongPasswordAccounts.length > 0 ? (
                                    this.renderPasswordTable(strongPasswordAccounts)
                                ) : (
                                    <div className={Style.emptyState}>No Safe passwords found</div>
                                )}
                            </div>
                        </div>
                    </div>
                </LoaderWrapper>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
     selectedRiskProfile : state.entities.credentialMonitoring.data.selectedRiskProfile,
     selectedCustomer: state.entities.customers.selectedCustomer,
     loading: state.entities.credentialMonitoring.selectedRiskProfileLoading,
});

const mapDispatchToProps = (dispatch) => ({
     loadRiskProfileById: (cid, userId) => dispatch(loadRiskProfileById(cid, userId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RiskProfileDetails);